module.exports = __webpack_public_path__ + "img/9788952752970.22a0040a.jpg";